import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api/config";
import { HTTP_STATUS } from "../../../app/constants";

const namespace = "items";

const initialState = {
  loading: null,
  itemsDetails: [],
  itemResponse: {},
  errorMessage: "",
};

//POST
export const addItemToServer = createAsyncThunk(
  `${namespace}/addItemToServer`,
  async (newItem, { rejectWithValue }) => {
    try {
      const response = await api.post("/item", newItem, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//GET
export const getItemsFromServer = createAsyncThunk(
  `${namespace}/getItemsFromServer`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/items", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//GET
export const getItemsFromServerByPagination = createAsyncThunk(
  `${namespace}/getItemsFromServerByPagination`,
  async ({ pageNo, rowSize }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/itemspagination?pageNo=${pageNo}&rowSize=${rowSize}`,
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//GET
export const getItemsCountFromServer = createAsyncThunk(
  `${namespace}/getItemsCountFromServer`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/itemscount", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//PATCH
export const updateItemInServer = createAsyncThunk(
  `${namespace}/updateItemInServer`,
  async (updatedItem, { rejectWithValue }) => {
    try {
      const id = parseInt(updatedItem.itemId);
      const response = await api.patch(`/item/${id}`, updatedItem, {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

//DELETE
export const deleteItemFromServer = createAsyncThunk(
  `${namespace}/deleteItemFromServer`,
  async (existingItem, { rejectWithValue }) => {
    try {
      const id = parseInt(existingItem.itemid);
      const loginUser = existingItem.loginUser;
      const response = await api.patch(
        `/deleteitem/${id}`,
        { params: { loginUser } },
        {
          headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
        }
      );
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue(err.response.data);
      } else {
        return rejectWithValue({
          message: "Network error or server not reachable",
        });
      }
    }
  }
);

export const itemSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addItemToServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(addItemToServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.itemResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(addItemToServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.itemResponse = {};
        state.errorMessage = error.errorMessage;
      })
      .addCase(getItemsFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getItemsFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.itemsDetails = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(getItemsFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.itemsDetails = [];
        state.errorMessage = error.errorMessage;
      })
      .addCase(getItemsFromServerByPagination.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getItemsFromServerByPagination.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.errorMessage = null;
      })
      .addCase(getItemsFromServerByPagination.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.itemsDetails = [];
        state.errorMessage = error.message;
      })
      .addCase(getItemsCountFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getItemsCountFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.errorMessage = null;
      })
      .addCase(getItemsCountFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.errorMessage = error.errorMessage;
      })
      .addCase(updateItemInServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(updateItemInServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.itemResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(updateItemInServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.itemResponse = {};
        state.errorMessage = error.message;
      })
      .addCase(deleteItemFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(deleteItemFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.itemResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(deleteItemFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.itemResponse = {};
        state.errorMessage = error.errorMessage;
      });
  },
});

export const selectAllItems = (state) => state.items.itemsDetails;
export const selectLoadingStatus = (state) => state.items.loading;
export default itemSlice.reducer;
